import api from '../apis/constants';

export interface ConfigItem {
    value: string;
    label: string;
    label_en: string;
}

export interface ProductConfig {
    purposes: ConfigItem[];
    materials: ConfigItem[];
    sizes: ConfigItem[];
    brands: ConfigItem[];
    weaving: ConfigItem[];
    printing: ConfigItem[];
    finishing: ConfigItem[];
    care: ConfigItem[];
}

class ProductConfigService {
    async getProductConfig(): Promise<ProductConfig> {
        const response = await api.get('/home/product-config');
        return response.data.data;
    }

    async updateProductConfig(config: ProductConfig): Promise<void> {
        await api.put('/home/product-config', config);
    }
}

export default new ProductConfigService();
